import axios from 'axios'

const currentUrl = window.location.href
const scheduleWidget = document.querySelector('lk-schedule')

// Когда виджет встроен на сторонний сайт, window.location.href — это URL стороннего сайта,
// поэтому окружение определяем ещё и по атрибутам тега виджета (domain, data-src).
const detectionUrl = [
    currentUrl,
    scheduleWidget?.getAttribute('domain') || '',
    scheduleWidget?.getAttribute('data-src') || '',
].join(' ')

//let baseURL = 'http://api.fitbase.local/api/v1.1/'
let baseURL = 'https://api.fitbase.io/api/v1.1/'
let domain = document.getElementById('app')?.dataset?.domain
    || scheduleWidget?.getAttribute('data-subdomain')
    || 'demo'

switch (true) {
    case detectionUrl.includes('pandem1c.devops'):
        baseURL = 'https://api.pandem1c.devops.fitbase.io/api/v1.1/'
        domain = 'pandem1c'
        break
    case detectionUrl.includes('staging-test'):
        baseURL = 'https://api-staging-test.dev.fitbase.team/api/v1.1/'
        domain = 'staging-test'
        break
    case detectionUrl.includes('predprod'):
        baseURL = 'https://api.predprod.dev.fitbase.team/api/v1.1/'
        domain = 'predprod'
        break
    case detectionUrl.includes('staging'):
    case detectionUrl.includes('dev.fitbase.team'):
        baseURL = 'https://api-staging.dev.fitbase.team/api/v1.1/'
        domain = 'staging'
        break
    case detectionUrl.includes('test.devops'):
        baseURL = 'https://api-test.devops.fitbase.io/api/v1.1/'
        domain = 'test'
        break
    case detectionUrl.includes('fitbase.local'):
    case detectionUrl.includes('localhost'):
        baseURL = 'http://api.fitbase.local/api/v1.1/'
        domain = 'demo'
        break
}

const instance = axios.create({
    baseURL: baseURL,
    headers: {
        Club: domain,
        Source: 'personal'
    }
})

instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('fitbase_token');

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    },

    (error) => {
        return Promise.reject(error);
    }
);

export default instance
